import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SG_CLICK_CONFIRM_PLUGIN } from '../../../../click-confirm.service';
import { SgClickConfirmDialogContainer } from './container.component';
import { SgClickConfirmDialogPlugin } from './plugin';

@NgModule({
  imports: [CommonModule],
  declarations: [SgClickConfirmDialogContainer],
})
export class SgClickConfirmDialogPluginModule {
  static readonly PLUGIN = SgClickConfirmDialogPlugin;
}
